import * as React from "react";
import { Typography, Container, Box } from "@material-ui/core";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { ClosedReportContainer } from "../components/reporting/ClosedReportContainer";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";

const ClosedAuctionReporting = () => (
  <Container maxWidth={"lg"} fixed>
    <SecureArea memberPermission={MemberPermission.BucketAdmin}>
      <Typography variant="h4" color="primary" gutterBottom>
        Closed Auction reports
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Create an export for closed auctions reports
      </Typography>
      <Box mt={4}>
        <ClosedReportContainer />
      </Box>
    </SecureArea>
  </Container>
);

export default withAITracking(reactPlugin, ClosedAuctionReporting, "ClosedAuctionReporting");
